import React from 'react';
import './InspectionOnsiteDocumentCard.css';
import _ from 'lodash';
import { FaLink } from 'react-icons/fa';
import { get, getTimestampString } from '../../../utility/utility';
import CoreCard from '../../core/content/CoreCard';

function InspectionOnsiteDocumentCard({
  document, primaryAction, secondaryActions, isLoading, isLinked,
}) {
  const documentType = get(document, 'type', false);
  return (
    <CoreCard
      content={(
        <div className="inspection-onsite-document-card-container">
          <div style={{ paddingLeft: '10px', color: 'var(--color-grey900)', fontWeight: '500' }}>
            <span
              style={{
                cursor: (isLoading ? null : 'pointer'),
                textDecoration: 'underline',
              }}
              onClick={isLoading ? null : primaryAction}
            >
              {documentType ? `${_.startCase(documentType)}`: get(document, 'filename')}
            </span>
            {isLinked ? (
              <span style={{ paddingLeft: '10px', color: 'var(--color-grey700)' }}>
                <FaLink /> 
              </span>
            ) : null}
          </div>
          <div style={{ fontStyle: 'italic', paddingLeft: '10px', color: 'var(--color-grey700)' }}>
            {`${get(document, 'roleVisibility', []).join(', ')}`}
          </div>
          {isLoading ? null : (
            <div style={{ paddingLeft: '10px', color: 'var(--color-grey700)' }}>
              {get(getTimestampString(get(document, 'storedAt')), 'all', '')}
            </div>
          )}
        </div>
      )}
      actions={secondaryActions}
      isLoading={isLoading}
    />
  );
}

export default InspectionOnsiteDocumentCard;
